
<template>
  <div class="date-selector">
    <div class="last-day" @click="clickLast" :class="{'disabled-color': reachBottom}">前一日</div>
    <div class="current-day">{{formatDateByDate(valueDate)}}</div>
    <div class="next-day" @click="clickNext" :class="{'disabled-color': reachTop}">后一日</div>
  </div>
</template>
<script>
import util from '../utils/utils.js'
export default {
  props: {
    value: {
      type: Number,
      default: util.formatDateByDate(new Date().getTime())
    },
    minDateNumber: Number,
    maxDateNumber: Number
  },
  computed: {
    valueDate () {
      return this.startOfADay(this.value)
    },
    minDate () {
      return this.startOfADay(this.minDateNumber)
    },
    maxDate () {
      return this.startOfADay(this.maxDateNumber)
    },
    reachBottom () {
      return this.formatDateByDate(this.valueDate) <= this.formatDateByDate(this.minDate)
    },
    reachTop () {
      return this.formatDateByDate(this.valueDate) >= this.formatDateByDate(this.maxDate)
    }
  },
  created () {
    if (this.value) {
      this.$emit('input', this.startOfADay(this.value))
    }
  },
  methods: {
    formatDateByDate: util.formatDateByDate,
    datePlusOneDay: util.datePlusOneDay,
    dateMinusOneDay: util.dateMinusOneDay,
    startOfADay: util.startOfADay,
    clickLast () {
      if (this.reachBottom === false) {
        this.$emit('input', this.startOfADay(this.dateMinusOneDay(this.value)))
      }
    },
    clickNext () {
      if (this.reachTop === false) {
        this.$emit('input', this.startOfADay(this.datePlusOneDay(this.value)))
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var'

  .date-selector
    font-size $small-font-size
    background-color white
    display flex
    justify-content space-around
    align-items center
    width 100%
    height 54.4pt
    color $primary-color
    line-height 20pt
    depth(1)
    .current-day
      font-size $normal-font-size
      padding 0 15pt
      border-radius 10pt
      border 1px solid
    .last-day, .next-day
      border  solid transparent
      font-size $small-font-size
  .disabled-color
    color $disable-text-color
    cursor not-allowed
</style>



// WEBPACK FOOTER //
// date-selector.vue?7445317d